module.exports = __webpack_public_path__ + "img/mg-live.a1f057a2.png";